import axios from 'axios';
import * as Constants from "../constants";


class ProductService {
    list(country) {
        return axios.get(Constants.API_URL + 'v2/product/list?country=' + country)
            .then(response => {
                return response.data;
            });
    }
}

export default new ProductService();
